import {
  Grid,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableBody,
} from "@mui/material";
import React from "react";
import {
  BaseGrid,
  StyledTableRow,
  TableCellHeader,
  TableCellWidth,
  TitleTypography,
} from "../KandidatViewPage";
import { QuestionnaireResponse } from "../../../models/Questionnaire";

type Props = { data: QuestionnaireResponse[] };

export default function DataJawabanKandidatPage({ data }: Props) {
  return (
    <BaseGrid container item xs={12} justifyContent="center">
      <Grid
        container
        item
        xs={12}
        sx={{
          backgroundColor: "#00ACED",
          color: "#fff",
          marginBottom: "4%",
        }}
      >
        <TitleTypography>Data Jawaban Kandidat</TitleTypography>
      </Grid>
      <Grid container item xs={12}>
        <TableContainer component={Paper}>
          <Table size="small" aria-label="a dense table">
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "rgba(0,0,0,0.1)",
                }}
              >
                <TableCellHeader>Pertanyaan</TableCellHeader>
                <TableCellHeader>Jawaban</TableCellHeader>
                <TableCellHeader>Penjelasan</TableCellHeader>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, key) => (
                <StyledTableRow key={key}>
                  <TableCellWidth>{row.PERTANYAAN}</TableCellWidth>
                  <TableCellWidth>
                    {row.JAWABAN ? "Ya" : "Tidak"}
                  </TableCellWidth>
                  <TableCellWidth>{row.PENJELASAN}</TableCellWidth>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </BaseGrid>
  );
}
